import { format } from "date-fns";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_Row,
} from "material-react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TCompanySuspension } from "src/companySuspension/types";
import i18n from "src/shared/services/languages/i18n";
import getTableLang from "src/shared/services/languages/MaterialReactTable/getTableLang";
import FileDownloadButton from "../../../applications/shared/components/FileDownloadButton";
import useCustomMaterialTable from "src/shared/hooks/useCustomMaterialTable";

type TCompanySuspensions = {
  rows: TCompanySuspension[];
  mode: "suspension" | "obviation";
};
function CompanySuspensionsAndObviations(props: TCompanySuspensions) {
  const { rows, mode } = props;
  const { t } = useTranslation();
  const columns = useMemo<MRT_ColumnDef<TCompanySuspension>[]>(
    () =>
      [
        {
          accessorKey:
            mode === "suspension"
              ? "assembly_decision_id_suspend"
              : "assembly_decision_id_obviation",
          header: t("ΚΑΚ"),
        },
        {
          accessorKey: "descr",
          header: t("Αιτία"),
        },
        {
          accessorFn: (row: TCompanySuspension) => {
            if (mode === "suspension" && row.date_of_suspension) {
              return format(
                new Date(row.date_of_suspension),
                "dd/MM/yyyy HH:mm:ss",
              );
            } else if (mode === "obviation" && row.date_of_obviation) {
              return format(
                new Date(row.date_of_obviation),
                "dd/MM/yyyy HH:mm:ss",
              );
            } else {
              return "";
            }
          },
          header:
            t(
              mode === "suspension"
                ? "Ημερομηνία Αναστολής"
                : "Ημερομηνία Άρσης",
            ) ?? "",
        },
        {
          Cell: ({ row }: { row: MRT_Row<TCompanySuspension> }) => {
            return (
              <FileDownloadButton
                params={[
                  {
                    key: "fileName",
                    value: row.original.annfile_filename.split("/")[4],
                  },
                  {
                    key: "gemiId",
                    value: row.original.company_id.toString(),
                  },
                ]}
                url={`${import.meta.env.VITE_APP_API_URL}/document/downloadFileSuspension`}
                text={t("Ανακοίνωση Αναστολής")}
              />
            );
          },
          header: t("Αρχείο Ανακοίνωσης"),
        },
        mode === "suspension" && {
          accessorFn: (row: TCompanySuspension) =>
            !row.date_of_obviation ? t("Ενεργή") : t("Ανενεργή"),
          header: t("Κατάσταση"),
        },
      ].filter(Boolean) as MRT_ColumnDef<TCompanySuspension>[],
    [i18n.language],
  );
  const table = useCustomMaterialTable({
    columns,
    data: rows,
    enableStickyHeader: true,
    localization: getTableLang(),
    enableTopToolbar: false,
    enableSorting: false,
    enableColumnActions: false,
  });
  return (
    <>
      <h4>
        {t(
          mode === "suspension"
            ? "Ανακοινώσεις αναστολών καταχώρησης"
            : "Ανακοινώσεις άρσεων αναστολών καταχώρησης",
        )}
      </h4>
      <MaterialReactTable table={table} />
    </>
  );
}

export default CompanySuspensionsAndObviations;
